export default __webpack_public_path__ + "static/media/cl1.6db46aa5.webp";